import { Component, inject, model } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ExportStatus } from '@api-types/enums/export-status.enum';
import { DateUtilsService } from '@core/utils/date-utils.service';
import { PmIconComponent } from '@libs/ui';
import { TranslateModule } from '@ngx-translate/core';
import { ConsensusExportStateService } from 'demand-forecasting/store/consensus/consensus-export-state.service';
import { LucideLoaderCircle, LucideCircleX } from '@lucide/angular';

@Component({
  selector: 'pm-consensus-export-list-tab',
  templateUrl: './consensus-export-list-tab.component.html',
  imports: [
    TranslateModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    PmIconComponent,
  ],
})
export class ConsensusExportListTabComponent {
  protected readonly stateService = inject(ConsensusExportStateService);
  protected readonly dateUtilsService = inject(DateUtilsService);

  protected readonly ExportStatus = ExportStatus;
  protected readonly loaderIcon = LucideLoaderCircle;
  protected readonly errorIcon = LucideCircleX;

  selectedExportId = model<string | undefined>();
}
